import CategoryProducts, { getServerSideProps as s } from '../../../category/[category-name]/products';

export default CategoryProducts;
export const getServerSideProps = s;
